<div class="header">
  <input type="text" pInputText [(ngModel)]="query" i18n-placeholder="impersonation|Search placeholder" placeholder="Search..." (keyup.enter)="newSearch()"/>
  <p-button i18n-label="impersonation|Search button" label="Search" icon="pi pi-search" (click)="newSearch()" />
</div>
<p-dataview
  [value]="users"
  [totalRecords]="totalRecords"
  [rows]="pageSize"
  [rowsPerPageOptions]="pageSizeOptions"
  [loading]="isLoading"
  [lazy]="true"
  [lazyLoadOnInit]="false"
  (onLazyLoad)="onLazyLoad($event)"
  [loading]="isLoading"
  [paginator]="true"
  paginatorDropdownAppendTo="body"
  [alwaysShowPaginator]="false"
  >
  <ng-template #list let-items>
    @for(item of items; track item.clientNumber) {
      <div class="item">
        <div>
          <div>
            {{ `${item.firstname} ${item.lastname} (${item.company}, ${item.clientNumber})` }}
          </div>
          <div>
            {{ item.email }}
          </div>
        </div>
        <p-button i18n-label="impersonation|Impersonate button" label="Impersonate" (click)="impersonateUser(item.id)" />
      </div>
    }
  </ng-template>
</p-dataview>